export default __webpack_public_path__ + "static/media/work2.eb2bd2b9.jpeg";